import { marginTop, media } from "../../styles";
import { Button as BaseButton } from "../Button/Button";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
export type NavButtonsProps = {
  backLabel?: React.ReactNode;
  continueLabel?: React.ReactNode;
  navigationDisabled?: boolean;
  hideBack?: boolean;
  hideContinue?: boolean;
  onBack?: () => void;
  onContinue?: () => void;
};
const Container = styled.nav<{
  hideContinue?: boolean;
}>`
  width: 100%;
  display: flex;
  ${marginTop.l}

  flex-direction: ${({
  hideContinue
}) => hideContinue ? "row" : "row-reverse"};
  justify-content: space-between;

  @media ${media.mobile} {
    flex-direction: column;
    height: 6rem;
  }
`;
const Button = styled(BaseButton)`
  min-width: 10rem;

  @media ${media.mobile} {
    min-width: 100%;
  }
`;
export function NavButtons({
  backLabel,
  continueLabel,
  navigationDisabled,
  hideBack,
  hideContinue,
  onBack,
  onContinue
}: NavButtonsProps) {
  const {
    t
  } = useTranslation();
  return <Container hideContinue={hideContinue} data-sentry-element="Container" data-sentry-component="NavButtons" data-sentry-source-file="NavButtons.tsx">
      {hideContinue ? null : <Button onClick={onContinue} variant="primary" disabled={navigationDisabled}>
          {continueLabel ?? t("continue")}
        </Button>}
      {hideBack ? null : <Button onClick={onBack} variant="secondary" disabled={navigationDisabled}>
          {backLabel ?? t("back")}
        </Button>}
    </Container>;
}
export default NavButtons;